/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const patchedReserveUpdateRequestSchema = z
	.object({
		start_time: z.iso.datetime().optional(),
		table_id: z.uuid().optional(),
	})
	.describe("Перенос брони: время и стол можно менять по отдельности или вместе.");
